import { createApp } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { App, getRouter, vuetifyOptions, type IConfiguration } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { menus } from './sidebar-items';

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@/styles.css';

const config = {
  AppName: 'Scheduler',
  SiteNameShort: 'Scheduler',
  SiteNameLong: 'Ordonnanceur du solveur de planification',
  LogoLine1: 'Ordonnanceur du solveur',
  LogoLine2: 'de planification',
  Copyright: 'Copyright © 2026',
  SidebarItems: [],
  // Without this orientation, a section's groups are rendered as a horizontal
  // row and never appear in the side rail: the section showed up as a lone icon,
  // without its four views. This is the setting Parcours uses.
  MenuGroupsOrientation: 'vertical',
  Menus: menus,
  EnableAccessRequestButton: false,

  // Visual identity taken from Parcours (same brand, same blue), topped with a
  // "Scheduler" badge: the scheduler is a service of the Parcours family, not a
  // separate product.
  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',
  Logo: '/images/scheduler.svg',
  SiteLogo: '/images/scheduler.svg',
  SiteLogoAlt: '/images/scheduler-alt.svg',
  HideLoginLogo: true,
} as IConfiguration;

const vuetify = createVuetify({ components, directives, ...vuetifyOptions });

const app = createApp(App);
app.provide('config', config);
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon);
library.add(fas);
library.add(far);
app.use(createPinia());
// Same charting library as Parcours' frontend/: a single choice for the whole
// house, and the component pattern is already established there.
app.use(VueApexCharts);
app.use(PerfectScrollbarPlugin);
app.use(getRouter(getCustomRoutes));
app.mount('#app');
